import View from './views/DashboardMobile';

export default View;
